export const DEFAULT_LOCALE = 'en' as const
export type DEFAULT_LOCALE_TYPE = typeof DEFAULT_LOCALE
